import { useState } from "react";
import { FaServer } from "react-icons/fa6"; // Icon untuk NAS
import { InputDefault } from "../../../../../components/forms/InputDefault";
import { NasService } from "../../../../../services/NasService";
import { ModalWraper } from "../../../../../components/modal/wraper";
import { SelectPop } from "../../../../../components/forms/selects/SelectPop";


// ============================================
// MAIN COMPONENT: NasCreate
// ============================================
export const NasCreate = ({ open, setOpen, refreshData }) => {
  const [loading, setLoading] = useState(false);

  // Ubah struktur state menjadi formData agar konsisten dengan konsep baru
  const [formData, setFormData] = useState({
    pop_id: "",
    name: "",
  });

  const closeModal = () => {
    setOpen(false);
    setFormData({ name: "" });
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await NasService.create({ data: formData });

      console.log(res);
      closeModal();
      refreshData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWraper
      isOpen={open}
      setIsOpen={setOpen}
      title="Tambah Data NAS"
    >
      <form onSubmit={handleSubmit} className="space-y-5">

        <SelectPop
          id={"pop_id"}
          label={"Pilih Pop"}
          placeholder={"Pilih Pop"}
          value={formData.pop_id}
          setValue={(e) => setFormData({ ...formData, pop_id: e })}
          searchable={true}
        />

        {/* Input Nama NAS */}
        <InputDefault
          id={"name"}
          label={"Nama NAS"}
          type={"text"}
          placeholder={"Masukkan nama NAS (misal: Router01)"}
          value={formData.name}
          onChange={handleChange}
          // Error handling bisa ditambahkan disini jika perlu
          disabled={loading}
        />

        {/* Tombol Aksi */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={closeModal}
            className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 font-medium hover:bg-slate-800/50 transition-colors"
          >
            Batal
          </button>

          <button
            type="submit"
            disabled={loading}
            className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 disabled:text-slate-500 text-white font-semibold flex items-center justify-center gap-2 transition-all shadow-lg shadow-cyan-900/20"
          >
            {loading ? (
              <>Menyimpan...</>
            ) : (
              <>
                <FaServer />
                Simpan
              </>
            )}
          </button>
        </div>
      </form>
    </ModalWraper>
  );
};